import { doc, DocumentReference, getDoc } from 'firebase/firestore'
import medicalReimbursementServiceConfigs from './configs'
import { db } from '../../firebase/firebase'
import { MedicalReimbursement, MedicalReimbursementRaw } from '../../database/tables'
import MedicalReimbursementTableHelper from '../../database/tables/helpers/medical-reimbursement.helper'

export type GetMedicalReimbursementByIdParams = {
  id: string
}

export default async function getMedicalReimbursementById(
  params: GetMedicalReimbursementByIdParams,
): Promise<MedicalReimbursement> {
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = doc(
        db,
        medicalReimbursementServiceConfigs.collectionName,
        params.id,
      ) as DocumentReference<MedicalReimbursementRaw>
      const docSnap = await getDoc(docRef)

      if (docSnap.exists())
        return resolve(MedicalReimbursementTableHelper.fromRaw({ id: docSnap.id, rawData: docSnap.data() }))
      else throw new Error('Doc not found!')
    } catch (e) {
      return reject(e)
    }
  })
}
